import React from 'react'
import PropTypes from 'prop-types'
import TooltipComponent from '../utils/TooltipComponent'
import IconComponent from './IconComponent'
import ButtonComponent from './ButtonComponent'

const BackButtonComponent = ({ onClick, children, disabled }) => {
  return (
    <TooltipComponent content="Back" id="back-tooltip" placement="bottom">
      <ButtonComponent type="button" color="danger mb-1" onClick={onClick} disabled={disabled}>
        <IconComponent icon="Back" height="18" /> &nbsp;&nbsp;{children}
      </ButtonComponent>
    </TooltipComponent>
  )
}

BackButtonComponent.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
}

export default BackButtonComponent
